import React from 'react';
import { Stack, TextField, MenuItem, Typography, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import {
  HEALTH_STATUS_OPTIONS,
  PUNCTUALITY_STATUS_OPTIONS,
} from '../../utils/reportFilters';

/**
 * Shared filters for Reports (weekly + monthly).
 * Week/month navigation stays in each tab; this bar adds optional day, teacher, and status filters.
 */
export default function ReportsFilterBar({
  mode,
  weeklyTab,
  monthlyTab,
  filterDate,
  onFilterDateChange,
  filterTeacherId,
  onFilterTeacherChange,
  filterStatus,
  onFilterStatusChange,
  teachers = [],
  teachersLoading = false,
}) {
  const isWeekly = mode === 0;
  const showTeacher =
    isWeekly && (weeklyTab === 0 || weeklyTab === 1 || weeklyTab === 2);
  const showStatus = isWeekly && (weeklyTab === 0 || weeklyTab === 2);
  const statusOptions =
    weeklyTab === 2 ? PUNCTUALITY_STATUS_OPTIONS : HEALTH_STATUS_OPTIONS;

  const monthlyDateHint =
    !isWeekly && monthlyTab !== 5 ? (
      <Typography variant="caption" color="text.secondary" sx={{ alignSelf: 'center' }}>
        Day filter applies to Demos &amp; Trials only; other monthly views are month totals.
      </Typography>
    ) : null;

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignItems={{ xs: 'stretch', md: 'center' }}
      flexWrap="wrap"
      sx={{ mb: 2, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}
    >
      <TextField
        type="date"
        size="small"
        label="Specific date (optional)"
        value={filterDate}
        onChange={(e) => onFilterDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 200 }}
      />
      {filterDate ? (
        <IconButton
          size="small"
          aria-label="Clear date filter"
          onClick={() => onFilterDateChange('')}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      ) : null}

      {showTeacher ? (
        <TextField
          select
          size="small"
          label="Teacher"
          value={filterTeacherId}
          onChange={(e) => onFilterTeacherChange(e.target.value)}
          sx={{ minWidth: 200 }}
          disabled={teachersLoading}
        >
          <MenuItem value="">All teachers</MenuItem>
          {teachers.map((t) => (
            <MenuItem key={t.id} value={t.id}>
              {t.label}
            </MenuItem>
          ))}
        </TextField>
      ) : null}

      {showStatus ? (
        <TextField
          select
          size="small"
          label="Status"
          value={filterStatus}
          onChange={(e) => onFilterStatusChange(e.target.value)}
          sx={{ minWidth: 180 }}
        >
          {statusOptions.map((opt) => (
            <MenuItem key={opt.value || 'all'} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      ) : null}

      {monthlyDateHint}
    </Stack>
  );
}
